// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__qUG4k","newTemplateButton":"styles_newTemplateButton__YJuM3"};